var React = require('react');

function AccountIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Account Icon"),React.createElement("path",{"d":"M13.463 0C10.19 0 7.538 2.73 7.538 6.097v2.47c0 2.408 1.356 4.49 3.325 5.48l-6.96 2.895C1.596 17.603 0 19.765 0 22.229V23h27v-.765c0-2.467-1.6-4.63-3.91-5.29l-7.022-2.901c1.966-.993 3.32-3.072 3.32-5.477v-2.47C19.387 2.73 16.735 0 13.461 0m.003 14.963l1.933.8 7.021 2.902.094.038.097.028c1.173.334 2.074 1.264 2.427 2.417H1.961c.352-1.154 1.252-2.086 2.424-2.422l.098-.028.094-.039 6.96-2.894 1.928-.802m-.002-13.11c2.274 0 4.124 1.904 4.124 4.244v2.47c0 1.632-.885 3.094-2.311 3.814l-1.81.913-1.812-.91c-1.429-.72-2.316-2.182-2.316-3.817v-2.47c0-2.34 1.85-4.245 4.125-4.245","fillRule":"evenodd","key":1})]);
}

AccountIcon.defaultProps = {"width":"27","height":"23"};

module.exports = AccountIcon;

AccountIcon.default = AccountIcon;
